import React from 'react'
import type { Icon } from 'shared/utils'

export const Crown = (props: Icon) => {
    const {
        color = 'black',
        size = 24,
        className = 'crown',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            className={className}
            viewBox="0 0 24 24"
            fill={color}
            {...otherProps}>
            <path
                className={'crown-path'}
                fill={color}
                d="M3.663 20.616a1.635 1.635 0 01-1.617-1.34L.014 8.377C-.125 7.591.799 7.036 1.4 7.5l4.942 3.74c.415.324 1.062.186 1.293-.276l3.603-6.513c.323-.6 1.2-.6 1.57 0l3.556 6.513c.278.462.878.6 1.294.277L22.6 7.545c.646-.508 1.524.046 1.385.877l-2.078 10.9a1.635 1.635 0 01-1.617 1.34l-16.627-.046z"
                fillRule="nonzero"
            />
        </svg>
    )
}
